// extracted by mini-css-extract-plugin
export default {"sortIcon":"TableHeader_sortIcon__PwCC3","tableHeader":"TableHeader_tableHeader__sU7k0","hasMultiselection":"TableHeader_hasMultiselection__jFESF"};